import { ChipProps } from "@mui/material";
import { ObjectType } from "../../../../Core/Api/Types/object-type";
import { DbAssetObjectInfos } from "../../../../Core/Api/Types/db-asset-object-infos";
import AssetTypeChip, { AssetTypeLogo } from "./asset-type-chip";
import { GetMetadataByTagName } from "../../../../Core/Utils/asset-object-utils";

export interface AssetTypeChipFromObjectProps extends ChipProps {
  obj: DbAssetObjectInfos;
  uncolored?: boolean;
}

const AssetTypeFromObjectChip: React.FC<AssetTypeChipFromObjectProps> = (props) => {
  const { obj, uncolored = false, ...otherProps } = props;
  let _logo: AssetTypeLogo | undefined = undefined;

  if (!obj || !obj.type) return <></>;
  if (
    obj.type === ObjectType.DolbyAtmosPackage ||
    GetMetadataByTagName(obj, "dolbyAtmosPackageType") /*||
    obj.name.includesAllWords("DAMF") ||
    obj.name.includesAllWords("atmos")*/
  )
    _logo = AssetTypeLogo.DolbyAtmosWhite;

  return <AssetTypeChip type={obj.type} uncolored={uncolored} logo={_logo} {...otherProps} />;
};

export default AssetTypeFromObjectChip;
